"use client";

import { useEffect, useCallback } from "react";
import { motion, useAnimationControls } from "framer-motion";
import Image from "next/image";
import OurWorkOverlay from "./OurWorkOverlay";

const OurWorkSection = () => {
  const imageControls = useAnimationControls();
  const startAnimation = useCallback(
    async (isMounted: { current: boolean }) => {
      while (isMounted.current) {
        await imageControls.start({
          x: "-15%",
          transition: { duration: 4, ease: "easeInOut" },
        });
        if (!isMounted.current) return;
        await new Promise((resolve) => setTimeout(resolve, 1500));
        if (!isMounted.current) return;
        await imageControls.start({
          x: "0%",
          transition: { duration: 4, ease: "easeInOut" },
        });
        if (!isMounted.current) return;
        await new Promise((resolve) => setTimeout(resolve, 1500));
      }
    },
    [imageControls]
  );

  useEffect(() => {
    const isMounted = { current: true };
    const timer = setTimeout(() => {
      startAnimation(isMounted);
    }, 2000);
    return () => {
      isMounted.current = false;
      clearTimeout(timer);
    };
  }, [startAnimation]);

  return (
    <section
      id="design-work"
      className="relative hidden sm:block mt-8 max-w-[1525px] h-[900px] w-full overflow-hidden"
    >
      <div className="absolute inset-0">
        <motion.div
          animate={imageControls}
          className="relative h-full w-[120%]"
          initial={{ x: "0%" }}
        >
          <Image
            src="/images/OurWork.png"
            alt="Our work showcase"
            fill
            className="object-cover object-center"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 100vw"
            quality={100}
          />
        </motion.div>
      </div>
      <OurWorkOverlay />
    </section>
  );
};

export default OurWorkSection;
